// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IPY9","footer":"styles_footer__1Sdfv"};